import { AppointmentDuration } from '@avanta/shared/constants/appointments';
import type { languages } from '@avanta/shared/constants/common';
import type { Psychologist } from '@avanta/shared/types/psychologists';
import { Building, Video } from 'lucide-react';
import {
  AppointmentType,
  type AppointmentTypeValue,
  type AppointmentDurationValue,
  type Steps,
  type TopPsychologist,
  type Flow,
  FLOW_MODES,
} from 'types/appointments';
import { type PackCheckout } from 'types/billing';

export type AppointmentsReserveFormData = {
  specialityBooked: number;
  contactMethod?: AppointmentTypeValue;
  city: string;
  backofficeCenterId: number;
  psychologist: Psychologist | null;
  filteredPsychologists: TopPsychologist[];
  dateTime: string;
  timezone: string;
  observations?: string;
  durationType: AppointmentDurationValue;
  language: keyof typeof languages | '';
  selectedPack: PackCheckout | null;
  flow: Flow;
};

export const defaultValues: AppointmentsReserveFormData = {
  specialityBooked: 0,
  contactMethod: undefined,
  city: '',
  backofficeCenterId: 0,
  psychologist: null,
  dateTime: '',
  observations: '',
  filteredPsychologists: [],
  timezone: '',
  durationType: AppointmentDuration.DURATION_DOUBLE,
  language: '',
  selectedPack: null,
  flow: FLOW_MODES.regular,
};

export const AppointmentsReservePayload = {
  specialityBooked: 'specialityBooked',
  backofficeCenterId: 'backofficeCenterId',
  contactMethod: 'contactMethod',
  dateTime: 'dateTime',
  psychologist: 'psychologist',
  observations: 'observations',
  durationType: 'durationType',
  // States
  city: 'city',
  language: 'language',
  timezone: 'timezone',
  filteredPsychologists: 'filteredPsychologists',
  selectedPack: 'selectedPack',
  flow: 'flow',
} as const;

export type StepProps = {
  nextStepName?: Steps;
  handleNext?: () => void;
  handleBack: (index?: number) => void;
};

export const CONTACT_METHODS = [AppointmentType.InPerson, AppointmentType.Video];

export const CONTACT_METHOD_ICONS = {
  [AppointmentType.InPerson]: Building,
  [AppointmentType.Video]: Video,
};
